import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 2 },
  { title: 'Tipo', flex: 1.2 },
  { title: 'Data da posição' },
  { title: 'Valor', flex: 1.2 },
  { title: 'Variação' },
];
